import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import React from 'react'

import 'normalize.css'
import 'Styles/reset.css'
import 'Styles/bootstrap-imports.scss'
import '../custom_modules/ml-common-styles/lib/ml-common.css'
import 'Styles/global.css'

import startPage from './containers/StartScreen'
import instructorPage from '../shared/containers/InstructorPage'
import params from '../client/lib/params'
import configure from './store'

const store = configure()
const history = syncHistoryWithStore(browserHistory, store)
const { isInstructorView } = params(window.location.href)

history.listen(() => {
  if (typeof window._arroyoPageLoad !== 'undefined') {
    window._arroyoPageLoad()
  }
})

const startScreen = isInstructorView ? instructorPage : startPage

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/lcrp" component={startScreen} />
    </Router>
  </Provider>
)
